import BaseSelect from '../BaseSelect';
import { BaseSelectOptionProps, SingleSelectProps } from '../BaseSelect/types';
import SingleSelectOption from './SingleSelectOption';

export default function Select<T>(props: SingleSelectProps<T>) {
  const {
    selected,
    placeholder,
    customOption,
    truncated,
    optionClassName,
    ...selectProps
  } = props;
  const buttonText =
    props.options?.find(({ value }) => value === selected)?.label ||
    placeholder;

  return (
    <BaseSelect
      buttonText={buttonText}
      activeElement={selected}
      closeOnSelect
      isMultiSelect={false}
      optionComponent={(props: BaseSelectOptionProps<T>) => {
        const { key, ...optionProps } = props;
        return (
          <SingleSelectOption
            key={key}
            name={selectProps.name}
            selected={selected}
            customOption={customOption}
            truncated={truncated}
            className={optionClassName}
            {...optionProps}
          />
        );
      }}
      {...selectProps}
    />
  );
}
